import { onMount, onDestroy } from "svelte";
import { Readable, get, writable } from "svelte/store";
export const useRendered = () => {
    let rendered = writable(false);
    onMount(() => rendered.set(true));
    onDestroy(() => rendered.set(false));
    return { rendered };
};
export const useDebounce = (func, delay) => {
    let timeoutId;
    const debounce = (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(null, args);
        }, delay);
    };
    onMount(() => {
        return () => {
            clearTimeout(timeoutId);
        };
    });
    return debounce.bind(func);
};
export const useUrls = ({ onBack, state, location, getUrl, isMoving = false, }) => {
    onMount(() => {
        const hashRoute = isMoving ? "#flytt/" : "#/";
        window.addEventListener("popstate", onBack);
        const currentUrl = new URL(location);
        const params = currentUrl.searchParams;
        params.delete("forbrukning");
        params.delete("postnr");
        params.delete("purchaseFlowVersion");
        params.delete("uuid");
        params.delete("oid");
        params.delete("aid");
        const updatedLocation = currentUrl.origin + currentUrl.pathname + (params.toString() ? `?${params.toString()}` : "");
        window.history.replaceState(null, "", `${updatedLocation}${hashRoute}${getUrl(get(state).value.toString())}`);
        const unsubscribe = state.subscribe((newState) => {
            window.history.pushState(null, "", `${updatedLocation}${hashRoute}${getUrl(newState.value.toString())}`);
        });
        return () => {
            unsubscribe();
            window.removeEventListener("popstate", onBack);
        };
    });
};
